import { useEffect } from "react";

export function useHandleMonitor(
  columns,
  removeMonitor,
  setMonitor,
  setColumns,
  monitor
) {
  useEffect(() => {
    if (!columns) {
      return;
    }
    const isMonitor = columns[0]?.[0].type === "monitor";
    if (removeMonitor && isMonitor) {
      setMonitor(columns[0]?.[0]);
      const newColumns = [...columns];
      newColumns[0].shift();
      setColumns(newColumns);
    }

    if (!removeMonitor && !isMonitor) {
      const newColumns = [...columns];
      newColumns[0].unshift(monitor);
      setColumns(newColumns);
    }
    // Intentionally only reacts to the removeMonitor toggle. Including
    // columns/monitor would re-run on every column change and add/remove the
    // monitor unexpectedly, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeMonitor]);
}
